import styled from 'styled-components';

export const LayoutWrapper = styled.div`
  display: grid;
  grid-template-columns: 320px 1fr;
  background: #ebebeb;
  height: 100dvh;
  overflow-y: auto;
`;
